<template>
  <b-row v-if="$route.name === 'EXSBOrderCreate'">
    <b-col cols="12">
      <router-link :to="{ name: 'EXSBOrderList' }" class="btn btn-default float-right">{{ $t('buttons.backToList') }}</router-link>
    </b-col>
    <b-col>
      <b-card>
        <div class="form-group" v-if="idExtractedOrder">
          <label class="form-control-label">{{ $t('views.excmtasktype.form.idCasesType') }}:</label>
          <model-select :options="caseTypesOptions" v-model="idCaseTypeForOrderExtraction"></model-select>
        </div>
        <Loader v-if="isLoading"></Loader>
        <EXSBOrderForm v-else
                :id-case-type-for-order-extraction="idCaseTypeForOrderExtraction"
                :id-extracted-order="idExtractedOrder"
                :handle-submit="onSendForm"
                :handle-update-field="updateField"
                :values="item"
                :errors="violations" />
      </b-card>
    </b-col>
  </b-row>
  <div v-else>
    <div class="form-group" v-if="idExtractedOrder">
      <label class="form-control-label">{{ $t('views.excmtasktype.form.idCasesType') }}:</label>
      <model-select :options="caseTypesOptions" v-model="idCaseTypeForOrderExtraction"></model-select>
    </div>
    <Loader v-if="isLoading"></Loader>
    <EXSBOrderForm v-else
                   :id-case-type-for-order-extraction="idCaseTypeForOrderExtraction"
                   :id-extracted-order="idExtractedOrder"
                   :id-firm="idFirm"
                   :id-case="idCase"
                   :id-contractor="idContractor"
                   :handle-submit="onSendForm"
                   :handle-update-field="updateField"
                   :values="item"
                   :errors="violations" />
  </div>
</template>

<script>
import EXSBOrderForm from './Form'
import Loader from '../../../Layout/Loader'
import { mapGetters, mapActions } from 'vuex'
import ApiService from '@/utils/ApiService'
import getId from '@/utils/getIdFromLink'
import { ModelSelect } from 'vue-search-select'

export default {
  components: {
    EXSBOrderForm,
    Loader,
    ModelSelect
  },
  props: ['idFirm', 'idContractor', 'idCase', 'idDuplicatedOrder', 'idExtractedOrder', 'initialItem'],
  data () {
    return {
      idCaseTypeForOrderExtraction: null,
      caseTypesOptions: [],
      item: {
        positions: [],
        orderTags: []
      }
    }
  },
  created () {
    if (this.idExtractedOrder) {
      this.getCaseTypes()
    }
  },
  mounted () {
    Object.assign(this.item, this.initialItem)
  },
  computed: mapGetters({
    error: 'exsborder/create/error',
    isLoading: 'exsborder/create/isLoading',
    created: 'exsborder/create/created',
    violations: 'exsborder/create/violations'
  }),
  watch: {
    idCase: {
      immediate: true,
      handler (val) {
        if (val) this.item.idCase = val
      }
    },
    // eslint-disable-next-line object-shorthand,func-names
    created: function (created) {
      if (!created) {
        return
      }
      if (this.$route.name === 'EXSBOrderCreate') {
        this.$router.push({ name: 'EXSBOrderShow', params: { id: created['@id'] } })
      } else if (created.idCase) {
        this.$router.push({ name: 'EXCMCaseShow', params: { id: created.idCase['@id'] } })
      }
    }
  },
  methods: {
    ...mapActions({
      create: 'exsborder/create/create'
    }),
    async getCaseTypes () {
      let params = { pagination: false }
      const response = await new ApiService('e_x_c_m_case_types', params).getResults()
      this.caseTypesOptions = response.items.map(entry => {
        return { value: entry['@id'], text: entry.title }
      })
      this.caseTypesOptions.unshift({ text: this.$t('global.notSet'), value: null })
    },
    async onSendForm () {
      let item = Object.assign({}, this.item)
      for (let i in item.positions) {
        item.positions[i].quantity = parseFloat(item.positions[i].quantity)
      }
      if (item.firm === '') {
        item.firm = undefined
      }
      if (item.contractor === '') {
        item.contractor = undefined
      }
      if (item.idCase === '') {
        item.idCase = undefined
      }
      item.orderTags = this.item.orderTags.map(object => {
        return { tag: object.value }
      })
      if (this.idDuplicatedOrder) {
        let data = { '@id': this.idDuplicatedOrder, state: 0 }
        const response = await new ApiService(`e_x_s_b_orders/${getId(data['@id'])}`).putSilent(data)
        if (response.status === 200) { // Duplikacja nowego zamówienia tylko wtedy gdy udało się zarchiwizować poprzednie
          this.create(item)
        }
      } else if (this.idExtractedOrder) {
        let data = { '@id': this.idExtractedOrder, state: 0 }
        const response = await new ApiService(`e_x_s_b_orders/${getId(data['@id'])}`).putSilent(data)
        if (response.status === 200) { // Duplikacja nowego zamówienia tylko wtedy gdy udało się zarchiwizować poprzednie
          item.extractOrder = 1
          item.idCaseTypeForOrderExtraction = this.idCaseTypeForOrderExtraction
          item.idExtractedOrder = this.idExtractedOrder
          this.create(item)
        }
      } else {
        this.create(item)
      }
    },
    updateField (field, value) {
      Object.assign(this.item, { [field]: value })
    }
  }
}
</script>
